import { Component, OnInit } from '@angular/core';
import { SearchService } from '../../search/search.service';
import { SearchParams } from '../../search/models/search-params.model';
import { SearchStatus } from '../../search/models/search-status.model';
import { ModalService } from '../../services/modal.service';
import { CoreServiceRegistry } from '../../../core/core-service-registry';
import { SharedServiceRegistry } from '../../shared-service-registry';
import { SearchCriteria, Condition, Clause } from '../../search/models/search-filter-model';
import { DataTableConfig } from '../../search/models/data-table-config';
import { SearchEvent } from '../../search/models/search-event';
import { NEW_SEARCH_EVENT } from '../../search/search-constants';
import { DataTableEditorService } from '../../search/results/data-table-editor.service';
import { AlertService } from 'sce-core';

@Component({
  selector: 'lfwms-wave-alloc-summary-popup',
  templateUrl: './wave-alloc-summary-popup.component.html',
  styleUrls: ['./wave-alloc-summary-popup.component.css']
})
export class WaveAllocSummaryPopupComponent implements OnInit {


  public lookupSearchService: SearchService;
  private _loadKeyWarningNoMap = {};
  private _waveKey: string ;

  constructor(public modalService: ModalService,
    private coreServiceRegistry: CoreServiceRegistry,
    private sharedServiceRegistry: SharedServiceRegistry,
    private alertService: AlertService) { }

  ngOnInit() {
  }
   /*
   Allocation operation is implemented as loadByPage call
    that returns allocation action status as table data.
 */
  public initializeComponents(waveKey: string, tableId: string, loadKeyList?: string[]) {
    this._waveKey = waveKey; 
    // initialize the table and search context */
    this.initializeLookupSearchContext(tableId);
    // call the allocate loadbypage for doing allocate action.
    this._doAllocateAndGetResponseTableData(waveKey, tableId, loadKeyList);
  }

  /* initialize the table and search context */
  public initializeLookupSearchContext(tableId: string) {

    const searchParams: SearchParams = new SearchParams();
    searchParams.tableId = tableId;
    searchParams.isFullFetch = true;
    searchParams.columnCount = 15; ///???
    /* Data editor is needed  for tableheader filter to work.
     Filter might misbehave if datatype is not set properly in metdata from db. */
    searchParams.tableEditor = new DataTableEditorService(this.coreServiceRegistry,
      this.sharedServiceRegistry);
    // Client side pagination enabled
    searchParams.paginateLocally = true;
    const tableConfig: DataTableConfig = new DataTableConfig();
    tableConfig.enablePagination = true;
    tableConfig.enableFilter = true;
    searchParams.dataTableConfig = tableConfig;
    const searchStatus: SearchStatus = new SearchStatus();
    this.lookupSearchService = this.sharedServiceRegistry.createSearchService(searchParams,
      searchStatus);

  }


  /*
  Allocate API call and get response as loadBypage call.
    - clears the search criteria used for loadBypage request
      since it will conflict with logic for localpagination's paging, sort, filter etc.
  */
  private _doAllocateAndGetResponseTableData(waveKey: string, tableId: string, loadKeyList?: string[]) {

    this.lookupSearchService.clearSearchStatus();
    /* above call required to clear of unexpected behaviour
   -not sending backend calls from second time when multiple parellel requests are sent */
    this.lookupSearchService.setSearchCriteria(this._getNewSearchCriteria(waveKey, tableId, loadKeyList));
    // not reflecting?? this.lookupSearchService.pagedData.pageDefinition.pageSize = 1000;
    // this.lookupSearchService.performSearch();
    this.lookupSearchService.fetchSearchResults()
      .subscribe((data: any) => {
        this.lookupSearchService.searchStatus.hasResults = true;
        this.lookupSearchService.searchStatus.recordCount = this.lookupSearchService.pagedData.pageDefinition.recordCount;
        const event = new SearchEvent(NEW_SEARCH_EVENT);
        event.isSearchSuccess = true;
        this.lookupSearchService.publishEvent(event);
        // LFWM-3892 Display Error and Success Messages
        const descrVal = this.lookupSearchService.pagedData.pageRows[0].cells['descr'].cVal;
        this.alertService.clearAll();
        if (descrVal === null) {
          this.alertService.success('Allocated Successfully');
        } else {
          this.alertService.error(descrVal);
        }
        // Clear search criteria to work with localPAgination
        this.lookupSearchService.setSearchCriteria(new SearchCriteria());
      });

  }

  /*
  Create custom search criteria for allocating wavekey/ multiple loadkeys.
  wavekey value is also required even if loadAlloc is done with values in loadKeyList.
  ** (Custom loadByPage request manipulation is done at backend
    as a specific case for alloc operation )
  */
  private _getNewSearchCriteria(waveKey: string, tableId: string, loadKeyList?: string[]) {

    // set isLoadShip true if at least one LoadKey passed.
    const isLoadAlloc = loadKeyList ? (loadKeyList.length > 0) : false;
    const searchCriteria = new SearchCriteria();
    // Function snippet to reuse clause creation within this method
    const _createSearchClause = (columName: string, value: any) => {
      const clause = new Clause();
      clause.operation = '=';
      clause.column = columName;
      clause.value = value;
      clause.logicalOperation = 'AND';
      return clause;
    };

    if (isLoadAlloc) {
      loadKeyList.forEach(loadKey => {
        /* Multiple Loadkeys needs to be sent in separate searchCondition,
        one searchCondition per loadKey */
        const searchCondition = new Condition();
        searchCondition.isMandatory = true;
        searchCondition.operator = 'OR';
        searchCondition.clauses = []; // Initialize clauses array
        //[LFWM-2715]- implementing allocation status popup 
        // if the table id is 'allocststtd' then only pass wavekey in searchCondtion,
        //  if table id is 'WAVEALLOCTD' then pass wavekey, loadKey and allocationType
        searchCondition.clauses.push(_createSearchClause('wavekey', waveKey));
        if(tableId === 'WAVEALLOCTD'){
          searchCondition.clauses.push(_createSearchClause('loadKey', loadKey));
          searchCondition.clauses.push(_createSearchClause('allocateType', ''));// Always ''
        } 
        searchCriteria.conditions.push(searchCondition);
      });
    } else {
      // No LoadKey, Allocate Wave => Only one searchCondition with Wavekey Clause
      // Response should be returning multiple loadkeys within the wave.
      const searchCondition = new Condition();
      searchCondition.isMandatory = true;
      searchCondition.operator = 'AND';

      searchCondition.clauses = []; // Initialize clauses array
      searchCondition.clauses.push(_createSearchClause('wavekey', waveKey));
      if(tableId === 'WAVEALLOCTD'){
        searchCondition.clauses.push(_createSearchClause('allocateType', ''));// Always ''
      } 
      searchCriteria.conditions.push(searchCondition);
    }
    return searchCriteria;
  }

}




// WEBPACK FOOTER //
// /home/runner/work/fbm-fulfillment-wms-client/fbm-fulfillment-wms-client/src/app/shared/lookup/wave-alloc-summary-popup/wave-alloc-summary-popup.component.ts